<template>
  <div>
    <b-form-group :label="label">
      <b-form-radio
        v-for="option in options"
        :key="option.id"
        v-model="selected"
        name="some-radios"
        :value="option.id"
        class="ml-2 mb-3"
      >
        {{ option.name }}
      </b-form-radio>
    </b-form-group>
  </div>
</template>

<script>
export default {
  name: "RadioFilter",
  data() {
    return {
      selected: this.selectedItem,
    };
  },
  props: {
    label: String,
    options: Array,
    selectedItem: String,
  },
  watch: {
    selected: function () {
      this.$emit("onFitlerSelect", this.selected);
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep {
  legend {
    font-weight: bold;
    font-size: 1rem;
    margin: 0;
  }
}
</style>
